import React from 'react';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styled from '@emotion/styled';
import { TagsInput } from '../components/TagsInput';

const FAQ_SCHEMA = [
  {
    key: 'faqTerms',
    label: 'Termos FAQ Geral',
    description: 'Palavras extras que o bot reconhece como pergunta de FAQ. Os termos padrão já estão incluídos.',
    defaultTags: ['estacionamento', 'horario', 'funciona', 'abre', 'fecha'],
  },
  {
    key: 'faqValorTerms',
    label: 'Termos FAQ Valor',
    description: 'Termos extras para perguntas de valor/preço.',
    defaultTags: ['quanto custa', 'valor', 'preco', 'quanto fica'],
  },
  {
    key: 'faqConveniosTerms',
    label: 'Termos FAQ Convênios',
    description: 'Termos extras para perguntas de convênios.',
    defaultTags: ['convenio', 'plano', 'aceita', 'particular'],
  },
  {
    key: 'faqEspecialidadesTerms',
    label: 'Termos FAQ Especialidades',
    description: 'Termos extras para perguntas de especialidades disponíveis.',
    defaultTags: ['especialidade', 'medico', 'doutor', 'atende'],
  },
  {
    key: 'faqProcedimentosTerms',
    label: 'Termos FAQ Procedimentos',
    description: 'Termos extras para perguntas sobre procedimentos oferecidos.',
    defaultTags: ['procedimento', 'exame', 'faz', 'realiza'],
  },
  {
    key: 'faqUnidadeTerms',
    label: 'Termos FAQ Unidade/Endereço',
    description: 'Termos extras para perguntas de localização/endereço.',
    defaultTags: ['endereco', 'onde fica', 'localizacao', 'telefone'],
  },
];

const ESCALONAMENTO_SCHEMA = [
  {
    key: 'transferTerms',
    label: 'Termos Transferência Humano',
    description: 'Palavras extras que ativam transferência para humano.',
    defaultTags: ['atendente', 'humano', 'pessoa', 'falar com alguem'],
  },
  {
    key: 'procedureTerms',
    label: 'Termos Procedimento',
    description: 'Procedimentos específicos da clínica que ativam transferência/agendamento.',
    defaultTags: [],
  },
];

export function TabClassificadores({ config, onChange }) {
  const handleChange = (key, value) => {
    onChange({ ...config, [key]: value });
  };

  return (
    <div style={{ fontFamily: "'Poppins', 'Helvetica', sans-serif" }}>
      <SectionTitle>Classificadores</SectionTitle>

      <Section>
        <SectionHeader><span>Prioridade</span></SectionHeader>
        <SectionBody>
          <Field>
            <FormControlLabel
              control={
                <Switch
                  checked={config.faqPriority || false}
                  onChange={(e) => handleChange('faqPriority', e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label={
                <div>
                  <SwitchLabel>FAQ Prioridade</SwitchLabel>
                  <Hint>
                    Quando ativo, perguntas com termos FAQ ganham prioridade sobre procedimento/transfer.
                    Ex: "procedimento dói?" vai pro FAQ em vez de transferir.
                  </Hint>
                </div>
              }
            />
          </Field>
        </SectionBody>
      </Section>

      <Section>
        <SectionHeader><span>Termos por Categoria</span></SectionHeader>
        <SectionBody>
          {FAQ_SCHEMA.map((field) => (
            <Field key={field.key}>
              <Label>{field.label}</Label>
              <Hint>{field.description}</Hint>
              <TagsInput
                value={config[field.key] || []}
                onChange={(tags) => handleChange(field.key, tags)}
                placeholder="Digite um termo e pressione Enter..."
                defaultTags={field.defaultTags}
              />
            </Field>
          ))}
        </SectionBody>
      </Section>

      <EscalonamentoSection>
        <EscalonamentoHeader><span>Escalonamento</span></EscalonamentoHeader>
        <SectionBody>
          {ESCALONAMENTO_SCHEMA.map((field) => (
            <Field key={field.key}>
              <Label>{field.label}</Label>
              <Hint>{field.description}</Hint>
              <TagsInput
                value={config[field.key] || []}
                onChange={(tags) => handleChange(field.key, tags)}
                placeholder="Digite um termo e pressione Enter..."
                defaultTags={field.defaultTags}
              />
            </Field>
          ))}
        </SectionBody>
      </EscalonamentoSection>
    </div>
  );
}

const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
`;

const Section = styled.div`
  background: #fff;
  border: 1px solid #219A97;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
`;

const EscalonamentoSection = styled.div`
  background: #fff;
  border: 1px solid #219A97;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
`;

const EscalonamentoHeader = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  padding: 8px 16px;
  background: #1b8c89;
  border-bottom: 1px solid #219A97;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const SectionHeader = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  padding: 8px 16px;
  background: #1b8c89;
  border-bottom: 1px solid #219A97;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const SectionBody = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
`;

const Hint = styled.span`
  font-size: 10.5px;
  color: #999;
  line-height: 1.3;
  display: block;
  margin-bottom: 4px;
`;

const SwitchLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
`;
